import { styled } from "@mui/material/styles";

const StyledShoppingCartModal = styled("div")(
  ({ theme }) => `
  .modal-container {
    width: 35%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 41px;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    background-color: ${theme.palette.background.paper};
    @media (max-width: 1024px) {
      width: 40%;
    }
    @media (max-width: 769px) {
      width: 65%;
    }
    @media (max-width: 426px) {
      width: 100%;
      right: 0px;
      top: 0px;

    }
    
  }

  .modal-content {
    width: 100%;
    height: 100%;
    background-color: ${theme.palette.background.paper};
    padding: 20px;
    display: flex;
    flex-direction: column;
    @media (max-width: 450px){
    padding: 20px;
    width: 88%;
    }
  }


  .modal-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    // @media (max-width: 600px){
    // margin-left: 0px;
    // }
    // @media (max-width: 400px){
    // margin-left: 0px;
    // }
    // @media (max-width: 350px){
    // margin-left:104px;
    // }
  }
    .heading-1{
    font-family: 'Lexend', sans-serif;
font-weight: 400;
font-size: 24px;
line-height: 30px;
color: ${theme.palette.primary.main}; 

    }

  .product-details {
    display: flex;
    align-items: flex-start;
    margin: 16px 0;
    // @media (max-width: 450px){
    // padding:10px;
    // }
  }

  .product-image {
    min-width: 102px;
    min-height: 106px;
    max-width: 102px;
    max-height: 106px;
    object-fit: cover;
    margin-right: 16px;
  }
  .product-info {
     word-break: break-all;
  }
    .heading-2{
      font-family: 'Belleza', sans-serif;
      font-weight: 400;
      font-size: 24px;
      line-height: 27.65px;
      color: ${theme.palette.primary.main};
      margin-top: 4px;
    }
    .heading-3{
      font-family: 'Lexend', sans-serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 17.5px;
      color: ${theme.palette.customColor.secondarySecond} !important;
      margin-top: 3px;
    }
    .heading-4{
      font-family: 'Lexend', sans-serif;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: ${theme.palette.primary.main}; 
      margin-top: 14px;
    }
    .size-selector {
      @media (max-width: 450px){
      height: fit-content;
    }
    }
  
    .size-options {
      display: flex;
      gap: 10px;
      width: 100%;
      height: max-content;
      flex-wrap: wrap;
      @media (max-width: 450px){
      width: 100%;
      height: 18px;
      padding: 10px;
      margin-left: -10px;
      flex-wrap: wrap;
    }
}

.size-box {
  width: 60px;
  position: relative;
  height: 40px;
  border: 0.8px solid ${theme.palette.primary.main};
  padding: 11px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: 'Lexend', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.palette.primary.main};
  transition: all 0.3s ease-in-out;
  box-sizing: border-box; 
  min-width: 0; /* allow flex child to shrink for ellipsis */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  // @media (max-width: 400px){
  //   max-width: 60px;
  // }
  // @media (max-width: 350px){
  //   max-width: 60px;
  // }
}

.size-box.selected {
  background-color:${theme.palette.customColor.lightbrown};
  color: ${theme.palette.customColor.white};
  border-color: ${theme.palette.customColor.lightbrown};
}


    .heading-5{
    font-family: 'Lexend', sans-serif;
font-weight: 500;
font-size: 16px;
line-height: 20px;
color: ${theme.palette.primary.main};
margin-bottom:15px;


    }
.heading-6{
    font-family: 'Lexend', sans-serif;
font-weight: 500;
font-size: 16px;
line-height: 20px;
color: ${theme.palette.primary.main}; 
margin-bottom: 16px;
    }
.title-1{
font-family: 'Lexend', sans-serif;
color: ${theme.palette.primary.main}; 
font-weight: 500;
font-size: 12px;
line-height: 18px;
}

  .Mui-disabled {
      background: #959595 !important;
      color: white !important;
  }

  .size-box {
    border: 1px solid ${theme.palette.customColor.secondaryThird};
    padding: 8px 6px;
    cursor: pointer;
    text-align: center;
    flex: 1;
    transition: border-color 0.3s ease;
    max-width: 80px !important;
    height: 32px;
    font-size: 12px;
    line-height: 15px;
    min-width: 0; /* allow flex child to shrink for ellipsis */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .size-text {
    display: block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .footer-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.08);
    width: calc(100% + 41px);
    height: 72px;
    background-color: ${theme.palette.customColor.white};
      @media (max-width: 450px){
      width: 100%;
    }
    
  }

  .width-footer{
    width: 100% !important;
    display: flex;
    gap: 30px;
    align-items: center;
    @media (max-width: 450px){
    width: 100% !important;
    gap: 30px;
    }
  }



     
.heading-9 {
  border: none;
  box-shadow: none;
  text-transform: none;
  background-color: ${theme.palette.primary.main}; 
  color: ${theme.palette.customColor.white}; 
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  max-height: 48px;
}

.heading-99 {
  border: none;
  box-shadow: none;
  text-transform: none;
  background-color: ${theme.palette.primary.main}; 
  color: ${theme.palette.customColor.white}; 
  max-height: 40px;
  margin-left: 19px;
  width: 90% !important;
  @media (max-width: 450px){
    width: 80% !important;
  }
}

.select-box {
  width: 493px;
  height: 48px;
}
.autocomplete-input-style {
  width: 100%;
}  

.Placeholder {
  font-family: 'Lexend', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 17.5px;
  color: ${theme.palette.customColor.grey}; 
}

.selected-text {
  color: ${theme.palette.primary.main} !important; 
}

.select-box input::placeholder {
  font-family: 'Lexend', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 17.5px;
  color: ${theme.palette.customColor.secondaryFourth}; 
}

.select-box input:not(:placeholder-shown) {
  color: ${theme.palette.primary.main} !important; 
}



.line {
  border-bottom: 1px solid ${theme.palette.customColor.secondaryThird}; 
  margin-bottom: 32px;
  margin-top: 32px;
}

.type-container {
  margin-bottom: 24px;
}

.type {
  font-family: 'Lexend', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${theme.palette.primary.main};
  text-transform: uppercase;
  margin-bottom: 8px;
}

.color-value,
.size-value {
  font-weight: 400;
  text-transform: none;
  margin-left: 4px;
}

.check-container {
  display: flex;
  gap: 12px;
}

.color-check {
  width: 26px;
  height: 26px;
  border-radius: 0;
}

.size-options-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.size-options {
  font-family: 'Lexend', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  width: 118px;
  height: 38px;
  border: 1px solid ${theme.palette.customColor.secondaryThird};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  
  /* Ensure text container stays centered - target the Box wrapper inside */
  & > div:first-of-type {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center;
    margin: 0;
    padding: 0;
  }
  
  /* Diagonal line for unavailable options (specific to size-options) */
  & .line {
    position: absolute;
    width: 105%;
    border-top: 1px solid ${theme.palette.customColor.secondaryThird};
    rotate: -18.5deg;
    top: 50%;
    left: -2.5%;
    z-index: 0;
    pointer-events: none;
    margin: 0;
    padding: 0;
    height: 0;
  }
  
  @media (max-width: 600px) {
    min-width: 17%;
    width: auto;
    height: 32px;
  }
}

.create-trip-description {
  font-family: 'Lexend', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${theme.palette.customColor.secondarySecond}; 
  margin-top: 4px;
  margin-bottom: 18px;
}

.replace-trip-container {
  width: 100%;
  padding: 5px;
  text-align: left;
}

.replace-title {
font-family: Lexend;
font-weight: 400;
font-size: 24px;
line-height: 30px;
}

.replace-description {
font-family: Lexend;
font-weight: 400;
font-size: 16px;
line-height: 24px;
  color: ${theme.palette.customColor.secondarySecond}; 
  margin-bottom: 20px;
}

.text-bold{
color: ${theme.palette.primary.main};
}

.replace-buttons {
  display: flex;
  justify-content: space-around;
  width: -webkit-fill-available;
  gap: 12px;
  margin: 16px 32px;
  position: relative;
}

.cancel-button {
  border: 1px solid ${theme.palette.primary.main} !important; 
  color: ${theme.palette.primary.main} !important; 
  width: 48%;
  margin-right: 0px !important;
    height: 40px !important;
    text-transform: none;
}

.replace-button {
  background-color: ${theme.palette.primary.main} !important; 
  color: ${theme.palette.customColor.white} !important; 
  width: 48%;
  margin-right: 0px !important;
    height: 40px !important;
        text-transform: none;
}


.trip-edit-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.palette.customColor.secondaryFirst}; /
  padding: 12px 16px;
  margin-bottom: 16px;
}

 .line1 {
    position: absolute;
    width: 116%;
    border-top: 1px solid ${theme.palette.customColor.secondaryThird};
    rotate: -27.5deg;
  }

.go-to-bag{
      background: ${theme.palette.secondary.main} !important;
}

  .error {
    font-family: 'Lexend', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: ${theme.palette.customColor.red};
  }

.MuiButton-loading{
background-color: ${theme.palette.customColor.secondaryFirst} !important;
color: ${theme.palette.customColor.secondarySecond} !important;
}

.trip-section {
  display: flex;
  align-items: center;
  gap: 6px;
}

.MuiButton-root {
  border-radius: 0px !important;
  width: 462px;
  height: 50px;
  margin-right: 22px;
  @media (max-width: 450px){
    width: 377px;
    padding: 10px;
    }
}



.favIcon{
 width: 22px;
 height: 22px;
 margin-left: 31px;
 position: relative;
}
 .products-container{
    padding-left: 0px;
    @media (max-width: 450px){
    padding-left: 10px;
    }
    
 }
 
.cards-container{
display: flex;
flex-direction: column;
gap: 12px;
}


.cart-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  // max-width: 495px;
}

.autocomplete-box, .dropdown-box1 {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px 8px 16px;
  border: 1px solid #ccc;
  background-color: white;
  cursor: pointer;
  margin-top:10px;
}

.buttons {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
}

.buttons svg, .datepicker svg {
  color: rgba(5, 5, 5, 1);
}

.autocomplete-input input {
  border: none !important;
  outline: none !important;
  font-family: 'Lexend', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 17.5px;
  color: ${theme.palette.primary.main}; 
}

.text-white {
cursor: pointer;
}

.close-icon {
position: absolute;
 right: 0;
  font-size: 20px !important;
  cursor: pointer;
}
 .autocomplete-input input:focus, .autocomplete-input input:hover,
.autocomplete-input input:active {
  color: black !important;
}   .custom-textfield {
     width: 100%;
      & .MuiInputBase-root {
        border: 1px solid #ccc  !important;
     
        &:before, &:after, &:focus, &:hover {
           border: 1px solid #ccc  !important;
        }
      }
      
  & .MuiOutlinedInput-notchedOutline {
        border: none !important;
      }

      &:focus-within .MuiOutlinedInput-notchedOutline {
        border: 1px  none !important;
      }
}
.custom-textfield input {
  border: none !important;
  outline: none !important;
  font-family: 'Lexend', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 17.5px;
  color:rgba(5, 5, 5, 1);
  margin-left: -2px;
  height: 15px;
  
}

   .MuiAutocomplete-input {
    // width: 0px;
    // min-width: 394px !important;
    // margin-left: 7px !important;
}
    // width: 88%;

.MuiInput-underline:before {
  display: none !important;
}

.MuiInput-underline:after {
  display: none !important;
}
.MuiOutlinedInput-root{
  border-radius:0px;
  width: 100%;
  margin-top: 10px;
}


.MuiAutocomplete-inputRoot{
padding-right: 0px !important;
}
.MuiSvgIcon-root{
color:rgba(5, 5, 5, 1);
}
.MuiAutocomplete-endAdornment {
    right: 1% !important;
}

`
);

export default StyledShoppingCartModal;
